import { type RefObject } from "react";
import { Button } from "react-ui";
import ReactDOM from "react-dom";

import { toHtmlElementOrNull } from "../../Commons/DOM/DomHelpers";

export const handleDropdownOpen = (buttonRef: RefObject<Button>) => {
    try {
        assertRefNotNull(buttonRef);

        const rootButtonElement = selectElementByRef(buttonRef);
        const button = selectButtonFromRootElement(rootButtonElement);
        button.click();
    } catch {
        return false;
    }

    return true;
};

const assertRefNotNull = (buttonRef: RefObject<Button>) => {
    if (!buttonRef.current) {
        throw new Error("Expect react component, but got null");
    }
};

const selectElementByRef = (buttonRef: RefObject<Button>) => {
    const element = toHtmlElementOrNull(ReactDOM.findDOMNode(buttonRef.current));

    if (!element) {
        throw new Error("Root element not found");
    }

    return element;
};

const selectButtonFromRootElement = (element: HTMLElement) => {
    const button = element.querySelector("button");

    if (!button) {
        throw new Error("Button not found");
    }

    return button;
};
